var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "content-block" }, [
    _c("div", { staticClass: "vlx-container" }, [
      _c("div", [
        _c(
          "div",
          { staticClass: "mb-7 sm:mb-14 sm:text-center max-w-2xl sm:mx-auto" },
          [
            _c("h2", [_vm._t("headline")], 2),
            _vm._v(" "),
            _c("div", { staticClass: "text-editor" }, [_vm._t("body")], 2)
          ]
        ),
        _vm._v(" "),
        _vm.accordionItems
          ? _c(
              "div",
              {
                staticClass:
                  "sm:flex sm:flex-nowrap items-start mb-4 sm:mb-12 last:mb-0"
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "relative mb-2 sm:mr-8 mx-auto sm:ml-0 lg:mr-16 sm:flex-1 lg:flex-auto w-full lg:max-w-lg"
                  },
                  [
                    _vm._l(_vm.accordionItems, function(item, index) {
                      return _c(
                        "div",
                        {
                          key: index,
                          staticClass:
                            "absolute group z-10 rounded-full focus:outline-none focus:ring-2 focus:ring-velux-blue focus:ring-offset-2",
                          style:
                            "left: " + item.left + "%; top: " + item.top + "%;",
                          attrs: { role: "button", tabindex: "0" },
                          on: {
                            click: function($event) {
                              return _vm.openAccordion(index)
                            },
                            keyup: function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              $event.preventDefault()
                              return _vm.openAccordion(index)
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass:
                                "relative w-10 h-10 border-2 border-color-velux-red text-lg inline-flex items-center justify-center rounded-full z-10 group-hover:bg-velux-red group-hover:text-velux-white transition-color duration-150",
                              class: {
                                "bg-velux-red text-velux-white": item.isOpen,
                                "bg-velux-white text-velux-red": !item.isOpen
                              }
                            },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(index + 1) +
                                  "\n                        "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("span", {
                            staticClass:
                              "absolute -left-1 -right-1 -top-1 -bottom-1 w-12 h-12 bg-velux-white z-10 rounded-full opacity-25"
                          })
                        ]
                      )
                    }),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass:
                          "overflow-hidden block aspect-w-6 aspect-h-5"
                      },
                      [_vm._t("image")],
                      2
                    )
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "hidden sm:block sm:flex-1 bg-velux-white text-velux-grey-900"
                  },
                  _vm._l(_vm.accordionItems, function(item, index) {
                    return _c("div", { key: index }, [
                      _c(
                        "div",
                        { attrs: { role: "heading", "aria-level": "3" } },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "flex items-center px-3 py-4 border-b-2 border-velux-grey-100 group focus:outline-none focus:ring-2 focus:ring-velux-blue focus:ring-offset-1 transition-all duration-150",
                              class: { "pointer-events-none": item.isOpen },
                              attrs: {
                                role: "button",
                                tabindex: "0",
                                "aria-expanded": item.isOpen,
                                "aria-controls":
                                  "accordion-panel-" + (index + _vm.id),
                                id: "accordion-trigger-" + (index + _vm.id)
                              },
                              on: {
                                click: function($event) {
                                  return _vm.openAccordion(index)
                                },
                                keyup: function($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  $event.preventDefault()
                                  return _vm.openAccordion(index)
                                }
                              }
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "inline-flex items-center" },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "w-8 h-8 inline-flex items-center mr-6 justify-center text-lg border-2 rounded-full flex-shrink-0 group-hover:bg-velux-red group-hover:text-velux-white group-hover:border-velux-red transition-color duration-150",
                                      class: item.isOpen
                                        ? "text-velux-white bg-velux-red border-velux-red"
                                        : "border-velux-grey-200"
                                    },
                                    [
                                      _vm._v(
                                        "\n                                        " +
                                          _vm._s(index + 1) +
                                          "\n                                    "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticClass: "text-left lg:text-xl",
                                      class: { "font-bold": item.isOpen }
                                    },
                                    [
                                      _vm._v(
                                        "\n                                        " +
                                          _vm._s(item.trigger) +
                                          "\n                                    "
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "ml-auto",
                                  class: item.isOpen
                                    ? "transform rotate-180 pr-5"
                                    : ""
                                },
                                [
                                  _c("i", {
                                    staticClass: "far fa-chevron-down fa-sm"
                                  })
                                ]
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", {
                        staticClass:
                          "bg-velux-grey-100 px-4 duration-100 ease-out transition-all overflow-hidden text-editor",
                        class: item.isOpen
                          ? "py-4 max-h-open-accordion"
                          : "max-h-0 py-0 invisible",
                        attrs: {
                          id: "accordion-panel-" + (index + _vm.id),
                          "aria-hidden": !item.isOpen,
                          "aria-labelledby":
                            "accordion-trigger-" + (index + _vm.id)
                        },
                        domProps: { innerHTML: _vm._s(item.content) }
                      })
                    ])
                  }),
                  0
                ),
                _vm._v(" "),
                _c("div", { staticClass: "sm:hidden" }, [
                  _c("div", { staticClass: "relative" }, [
                    _c(
                      "div",
                      { attrs: { role: "heading", "aria-level": "3" } },
                      [
                        _c(
                          "button",
                          {
                            staticClass:
                              "flex w-full items-center py-2 px-5 border-2 border-velux-grey-200 bg-velux-white text-velux-grey-900 mb-2",
                            attrs: {
                              "aria-haspopup": "listbox",
                              "aria-expanded": _vm.isListBoxOpen
                            },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.toggleListBox.apply(null, arguments)
                              }
                            }
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass:
                                  "w-8 h-8 inline-flex items-center mr-5 justify-center text-lg border-2 rounded-full text-velux-white bg-velux-red border-velux-red flex-shrink-0"
                              },
                              [
                                _vm._v(
                                  "\n                                    " +
                                    _vm._s(_vm.activeAccordionIndex + 1) +
                                    "\n                                "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("span", { staticClass: "font-bold text-left" }, [
                              _vm._v(
                                "\n                                    " +
                                  _vm._s(_vm.activeAccordion.trigger) +
                                  "\n                                "
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "ml-auto",
                                class: _vm.isListBoxOpen
                                  ? "transform rotate-180 pr-5"
                                  : "pl-5"
                              },
                              [
                                _c("i", {
                                  staticClass: "far fa-chevron-down fa-sm"
                                })
                              ]
                            )
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        ref: "listBox",
                        staticClass:
                          "absolute left-0 right-0 border-2 border-velux-grey-100 -mt-3 z-10 shadow-md p-0",
                        class: {
                          invisible: !_vm.isListBoxOpen,
                          "bottom-full": _vm.isListBoxUpwards
                        },
                        attrs: {
                          role: "listbox",
                          id: "listbox-options",
                          "aria-hidden": _vm.isListBoxOpen,
                          "aria-activedescendant":
                            "listbox-options-" +
                            (_vm.activeAccordionIndex + _vm.id)
                        }
                      },
                      _vm._l(_vm.accordionItems, function(item, index) {
                        return _c(
                          "div",
                          {
                            key: index,
                            staticClass:
                              "py-2 px-5 bg-velux-white hover:bg-velux-grey-100 text-velux-grey-900 flex items-center cursor-pointer border-t-2 border-velux-grey-100",
                            attrs: {
                              role: "option",
                              id: "listbox-options-" + (index + _vm.id),
                              "aria-selected": item.isOpen,
                              tabindex: "0"
                            },
                            on: {
                              keyup: function($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                $event.preventDefault()
                                return _vm.openAccordion(index)
                              },
                              click: function($event) {
                                return _vm.openAccordion(index)
                              }
                            }
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass:
                                  "w-8 h-8 inline-flex items-center flex-shrink-0 mr-5 justify-center text-lg border-2 rounded-full",
                                class: item.isOpen
                                  ? "text-velux-white bg-velux-red border-velux-red"
                                  : "text-velux-red bg-velux-white border-velux-red"
                              },
                              [
                                _vm._v(
                                  "\n                                    " +
                                    _vm._s(index + 1) +
                                    "\n                                "
                                )
                              ]
                            ),
                            _vm._v(
                              "\n                                " +
                                _vm._s(item.trigger) +
                                "\n                            "
                            )
                          ]
                        )
                      }),
                      0
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "bg-velux-grey-100 text-velux-grey-900 px-5 py-4 relative overflow-hidden"
                    },
                    _vm._l(_vm.accordionItems, function(item, index) {
                      return _c("div", {
                        key: index,
                        staticClass:
                          "text-editor duration-100 ease-linear transition-opacity",
                        class: item.isOpen
                          ? "opacity-100 relative"
                          : "opacity-0 absolute invisible",
                        attrs: {
                          "aria-hidden": !item.isOpen,
                          "aria-labelledby":
                            "listbox-options-" + (index + _vm.id)
                        },
                        domProps: { innerHTML: _vm._s(item.content) }
                      })
                    }),
                    0
                  )
                ])
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "flex justify-center" }, [_vm._t("cta")], 2)
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }